class SketchfabClient {

  constructor(sketchfabAPIUtilityInstance) {
    this.Utility = sketchfabAPIUtilityInstance;
    this.state = {
      previewing: false,
      firstTextureApplied: true,
      camera: {
        start: {
          "position": [
            150.86202528074074,
            -520.251036679495,
            383.7028644910366
          ],
          "target": [
            -0.0003166199,
            0.1391410828,
            193.5666993408
          ]
        },
        last: {
          "position": [
            150.86202528074074,
            -520.251036679495,
            383.7028644910366
          ],
          "target": [
            -0.0003166199,
            0.1391410828,
            193.5666993408
          ]
        },
        previewShirtFront: {
          "position": [
            40.815076567052344,
            -406.25124514577556,
            298.5657481274809
          ],
          "target": [
            -0.0003166199,
            0.1391410828,
            193.5666993408
          ]
        },
        previewShirtBack: {
          "position": [
            -70.77586796588702,
            398.67841635860486,
            311.8929854332468
          ],
          "target": [
            -0.0003166199,
            0.1391410828,
            193.5666993408
          ]
        },
      },
      cameraEasing: 'easeInOutCubic',
      textureTarget: false
    };

    const methods = [
      'init',
      'setListeners',
      'onUtilityReady',
      'onTextureApplied',
      'getScreenShot',
      'getPreviews',
      'getCamera',
      'setCamera',
      'saveCurrentCamera',
      'hide',
      'show',
      'togglePants',
      'getNodeMap',
      'getMaterialList',
      'getTextureList',
      'updateMaterials',
      'renderShirt',
      'renderPants',
      'buildNodeVisibilityTester',
      'methodNotFound',
    ];
    methods.forEach( (method) => {
      this[method] = this[method].bind(this);
    });

    this.init();
  }

  onUtilityReady() {
    // console.clear();
    console.info('onUtilityReady');

    // get data from localStorage
    // const base64DataStorage = localStorage.getItem('base64Data');
    // if(base64DataStorage){
    //   const data = JSON.parse(atob(base64DataStorage));
    //   state.currentModelKey = data.key;
    //   state.currentModel = models[data.key];
    //   state.currentModel.sections.shirt = data.shirt;
    //   state.currentModel.sections.pants = data.pants;
    // }

    // get data from querystring
    const base64DataQuery = getQueryString('data');
    if(base64DataQuery){
      const data = JSON.parse(atob(base64DataQuery));
      setModelFromData(data);
    }
    this.Utility.removeEventListener(this.Utility.EVENT_INITIALIZED, this.onSketchfabUtilityReady);
    this.getNodeMap('buildNodeVisibilityTester');
    this.Utility.api.setCameraEasing(this.state.cameraEasing);
    this.setListeners();
    this.renderShirt(state.currentModel);
    this.renderPants(state.currentModel);
    $('#show-modal-button').addClass('opacity100');
    $('.menu-responsive .list').addClass('fadeIn');
  };

  onTextureApplied(UIDKey){
    if(!this.state.firstTextureApplied){
      setTimeout(() => {
        this.getPreviews();
      }, 200);
      setTimeout(() => {
        $('.frame-loader').addClass('frame-loader--out');
        enableColorSelector();
        this.setCamera('start');
      }, state.currentModel.timings[7] + 300);
    }
    this.state.firstTextureApplied = false;
  }

  init() {
    console.info('init');
    this.Utility.addEventListener(this.Utility.EVENT_INITIALIZED, this.onUtilityReady);this.Utility.addEventListener(this.Utility.EVENT_TEXTURE_APPLIED, this.onTextureApplied);
    this.Utility.create();
  }

  setListeners() {
    console.info('setListeners');
    $('.sf-action').on('click', (e) => {
      let method = $(e.target).data('method') || false;
      let params = $(e.target).data('params') || false;
      if (typeof this[method] == 'undefined') { 
        method = 'methodNotFound';
        params = [$(e.target).data('method')];
      }

      if(params){
        this[method](params);
      }else{
        this[method]();
      }
    });

    $('#node-visibility-tester').on('change', () => {
      let instanceID = parseInt($('#node-visibility-tester option:selected').val());
      // console.log(instanceID);
      this.Utility.toggleNodeVisibility(instanceID);
    });

    $('#model-tester').on('change', () => {
      let model = $('#model-tester option:selected').val();
      let params = {};
      params.shirt = model;
      params.pants = 'modello1_pants.svg';
      // console.log(params);
      this.updateMaterials(params);
    });
  }

  getCamera() {
    console.info('getCamera');
    this.Utility.api.getCameraLookAt((err, camera) => {
      // console.log(err ? err : camera);
    });
  }

  setCamera(position = 'last', speed = .5, fov = 55, callback) {
    console.info('setCamera');
    // console.log(position);
    // console.info(speed);
    // console.info(fov);
    const camera = this.state.camera[position] || this.state.camera.last;
    this.Utility.api.lookat(
      camera.position,
      camera.target,
      speed, // duration of the animation in seconds
      callback
    );
    this.Utility.api.setFov(fov);
  }

  saveCurrentCamera(position = 'last') {
    console.info('saveCurrentCamera');
    var p = position;
    this.Utility.api.getCameraLookAt((err, camera) => {
      console.log(err ? err : camera);
      this.state.camera[p] = camera;
    });
  }

  hidePants(){
    this.hide(41);
    this.hide(42);
    this.hide(43);
    this.hide(58);
    this.hide(59);
    this.hide(60);
    this.hide(73);
  }

  showPants(){
    this.show(41);
    this.show(42);
    this.show(43);
    this.show(58);
    this.show(59);
    this.show(60);
    this.show(73);
  }

  hideShirt(){
    this.hide(3);
    this.hide(4);
    this.hide(5);
    this.hide(22);
    this.hide(23);
    this.hide(24);
    this.hide(94);
    this.hide(95);
    this.hide(96);
    this.hide(107);
    this.hide(118);
    this.hide(143);
    this.hide(144);
    this.hide(145);
    this.hide(162);
    this.hide(163);
    this.hide(164);
  }

  showShirt(){
    this.show(3);
    this.show(4);
    this.show(5);
    this.show(22);
    this.show(23);
    this.show(24);
    this.show(94);
    this.show(95);
    this.show(96);
    this.show(107);
    this.show(118);
    this.show(143);
    this.show(144);
    this.show(145);
    this.show(162);
    this.show(163);
    this.show(164);
  }

  getScreenShot(params) {
    this.Utility.api.getScreenShot(800, 800, 'image/png', function(err, result) {
      $('.preview').prepend(`<image src="${result}"><br>`);
    });
  }

  getPreviews(params = [600, 600]) {

    if(this.previewing){
      return false;
    }

    let timings = state.currentModel.timings;
    
    this.previewing = true;

    $('.preview').empty();

    this.saveCurrentCamera();

    this.setCamera('previewShirtFront', 0);

    setTimeout(() => {
      this.Utility.api.getScreenShot([200,200], 'image/png', function(err, result) {
        $('.preview').append(`<image src="${result}"><br>`);
        $('#quotationPreviewsFront').empty().append(`<image src="${result}"><br>`);
        $('#quotation_front_image_input').val(result);
        
      });
    }, timings[0]);

    setTimeout(() => {
      this.hidePants();
      this.Utility.api.getScreenShot(...params, 'image/png', function(err, result) {
        $('.preview').append(`<image src="${result}"><br>`);
        $('#shirt-image-front img').prop('src', result).removeClass('fadeOut slower').addClass('animated zoomIn fastest');
      });
    }, timings[1]);

    setTimeout(() => {
      this.showPants();
      this.hideShirt();
      this.Utility.api.getScreenShot(...params, 'image/png', function(err, result) {
        $('.preview').append(`<image src="${result}"><br>`);
        $('#pants-image-front img').prop('src', result).removeClass('fadeOut slower').addClass('animated zoomIn fastest');
      });
    }, timings[2]);

    setTimeout(() => {
      this.setCamera('previewShirtBack', 0);
    }, timings[3]);

    setTimeout(() => {
      this.Utility.api.getScreenShot(...params, 'image/png', function(err, result) {
        $('.preview').append(`<image src="${result}"><br>`);
        $('#pants-image-back img').prop('src', result).removeClass('fadeOut slower').addClass('animated zoomIn fastest');
      });
    }, timings[4]);

    setTimeout(() => {
      this.hidePants();
      this.showShirt();
      this.Utility.api.getScreenShot(...params, 'image/png', function(err, result) {
        $('.preview').append(`<image src="${result}"><br>`);
        $('#shirt-image-back img').prop('src', result).removeClass('fadeOut slower').addClass('animated zoomIn fastest');
      });
    }, timings[5]);

    setTimeout(() => {
      this.showPants();
      this.Utility.api.getScreenShot([200,200], 'image/png', function(err, result) {
        $('.preview').append(`<image src="${result}"><br>`);
        $('#quotationPreviewsBack').empty().append(`<image src="${result}"><br>`);
        $('#quotation_back_image_input').val(result);
      });
    }, timings[6]);

    setTimeout(() => {
      this.setCamera('last', 0);
      this.showPants();
      this.previewing = false;
    }, timings[7]);
  }


  getCompletePreviews(targetImgFront, targetImgBack, params = [800, 800]) {

    this.saveCurrentCamera();

    this.showPants();
    this.showShirt();

    this.setCamera('previewShirtFront', 0);

    setTimeout(() => {
      this.Utility.api.getScreenShot(...params, 'image/png', function(err, result) {
        $(targetImgFront+' img').prop('src', result);
      });
    }, 300);

    setTimeout(() => {
      this.setCamera('previewShirtBack', 0);
    }, 600);
      
    setTimeout(() => {
      this.Utility.api.getScreenShot(...params, 'image/png', function(err, result) {
        $(targetImgBack+' img').prop('src', result);
      });
    }, 900);

    setTimeout(() => {
      this.setCamera('last', 0);
      // this.togglePants();
    }, 1200);

  }

  renderShirt(model = {}) {

    disableColorSelector();
    
    this.textureTarget = 'shirt';
    console.log(model);
    $('.frame-loader').removeClass('frame-loader--out');
    $('.shirt-wrapper img').removeClass('zoomIn fastest').addClass('animated fadeOut slower');
    const data = {
      "key": model.key,
      "filename": model.filename,
      "userId": state.user.ID || 0,
      "shirt": model.sections.shirt,
      "pants": model.sections.pants,
      "images": model.images
    };

    const base64Data = window.btoa(JSON.stringify(data));

    this.Utility.removeTextureFromMaterialChannel("shirt", this.Utility.AlbedoPBR);

    const d = new Date();

    let host = location.protocol + '//' + window.location.hostname;
    host = 'https://mygsgkit.giessegi.com';
    const path = '/wp-content/themes/coloratu3/svg-generator/?data=' + base64Data + '&t=' + d.getTime();
    const URL = host + path;
    console.log('SVG shirt URL: ' + URL);

    // history.replaceState(data, model.name, "?data=" + base64Data);

    // const cacheID = "shirt-" + model.filename;
    const cacheID = "shirt";

    this.Utility.setMaterialUIDPending("shirt", this.Utility.AlbedoPBR, cacheID);

    this.Utility.addTexture(URL, cacheID, false);
  }

  renderPants(model = {}) {

    disableColorSelector();
    
    this.textureTarget = 'pants';
    $('.frame-loader').removeClass('frame-loader--out');
    $('.pants-wrapper img').removeClass('zoomIn fastest').addClass('animated fadeOut slower');
    const data = {
      "key": model.key,
      "filename": "pants.svg",
      "userId": state.user.ID || 0,
      "shirt": model.sections.shirt,
      "pants": model.sections.pants,
      "images": model.images
    };

    const base64Data = window.btoa(JSON.stringify(data));

    this.Utility.removeTextureFromMaterialChannel("pants_1", this.Utility.AlbedoPBR);
    this.Utility.removeTextureFromMaterialChannel("pants_2", this.Utility.AlbedoPBR);

    const d = new Date();

    let host = location.protocol + '//' + window.location.hostname;
    host = 'https://mygsgkit.giessegi.com';
    const path = '/wp-content/themes/coloratu3/svg-generator/?data=' + base64Data + '&t=' + d.getTime();
    const URL = host + path;
    console.log('SVG pants URL: ' + URL);

    // history.replaceState(data, model.name, "?data=" + base64Data);

    //const cacheID = "pants-" + model.filename;
    const cacheID = "pants";

    this.Utility.setMaterialUIDPending("pants_1", this.Utility.AlbedoPBR, cacheID);
    this.Utility.setMaterialUIDPending("pants_2", this.Utility.AlbedoPBR, cacheID);

    this.Utility.addTexture(URL, cacheID, false);
  }

  methodNotFound(params) {
    console.warn(`Method "${params[0]}" not found`);
  }





  getNodeMap(callback = false) {
    // console.log('getNodeMap');
    this.Utility.api.getNodeMap((err, nodes) => {
      // console.log(err ? err : nodes);
      this.nodeMap = nodes;
      if(callback){
        this[callback]();
      }
    });
  }

  buildNodeVisibilityTester() {
    const nvt = $('#node-visibility-tester');
    nvt.empty();
    for (let node in this.nodeMap) {
      if(this.nodeMap[node].instanceID > 2){
        let option = `<option value="${this.nodeMap[node].instanceID}">${this.nodeMap[node].name} (${this.nodeMap[node].instanceID} - ${this.nodeMap[node].type} )</option>`;
        nvt.append(option);
      }
    }
  }

  hide( instanceId = 0 ) {
    // console.log('Hide');
    this.Utility.api.hide(instanceId);
  }

  show( instanceId = 0 ) {
    // console.log('Show');
    this.Utility.api.show(instanceId);
  }

  togglePants() {
    console.log('Toggle Pants');
    this.Utility.toggleNodeVisibility(41);
    this.Utility.toggleNodeVisibility(42);
    this.Utility.toggleNodeVisibility(43);
    this.Utility.toggleNodeVisibility(58);
    this.Utility.toggleNodeVisibility(59);
    this.Utility.toggleNodeVisibility(60);
    this.Utility.toggleNodeVisibility(73);
  }


  getShirtPreviews(params = [800, 800]) {

    this.hidePants();

    this.saveCurrentCamera();

    this.setCamera('previewShirtFront', 0);
    
    /* Test callback
    this.Utility.api.getScreenShot(...params, 'image/png', (err, result) => {
      $('#shirt-image-front img').prop('src', result).removeClass('fadeOut slower').addClass('animated zoomIn faster');
      this.setCamera('previewShirtBack', 0, 55, () => {
        this.Utility.api.getScreenShot(...params, 'image/png', (err, result) => {
          $('#shirt-image-back img').prop('src', result).removeClass('fadeOut slower').addClass('animated zoomIn faster');
          this.setCamera('last', 0);
          this.togglePants();
        });
      });
    });
    */

    setTimeout(() => {
      this.Utility.api.getScreenShot(...params, 'image/png', function(err, result) {
        $('#shirt-image-front img').prop('src', result).removeClass('fadeOut slower').addClass('animated zoomIn fastest');
      });
    }, 300);

    setTimeout(() => {
      this.setCamera('previewShirtBack', 0);
    }, 600);
      
    setTimeout(() => {
      this.Utility.api.getScreenShot(...params, 'image/png', function(err, result) {
        $('#shirt-image-back img').prop('src', result).removeClass('fadeOut slower').addClass('animated zoomIn fastest');
      });
    }, 900);

    setTimeout(() => {
      this.setCamera('last', 0);
      this.showPants();
    }, 1200);

  }


  getPantsPreviews(params = [800, 800]) {

    this.saveCurrentCamera();

    this.showPants();

    this.setCamera('previewShirtFront', 0);

    setTimeout(() => {
      this.Utility.api.getScreenShot(...params, 'image/png', function(err, result) {
        $('#pants-image-front img').prop('src', result).removeClass('fadeOut slower').addClass('animated zoomIn fastest');
      });
    }, 300);

    setTimeout(() => {
      this.setCamera('previewShirtBack', 0);
    }, 600);
      
    setTimeout(() => {
      this.Utility.api.getScreenShot(...params, 'image/png', function(err, result) {
        $('#pants-image-back img').prop('src', result).removeClass('fadeOut slower').addClass('animated zoomIn fastest');
      });
    }, 900);

    setTimeout(() => {
      this.setCamera('last', 0);
      // this.togglePants();
    }, 1200);

  }

  getMaterialList() {
    console.log('getMaterialList');
    this.Utility.api.getMaterialList( (err, materials) => {
      console.log(err ? err : materials);
      let url ='https://mygsgkit.giessegi.com/esempio-sketchfab/images/outfits/shirt_variation_9_4096x4096.png';

      // for (var i = 0; i < materials.length; i++) {
      //   var m = materials[i];
      //   m.channels.AlbedoPBR.factor = 1;
      //   console.log(m);
      //   // this.api.updateTexture(url, m.channels.AlbedoPBR.texture.uid, (/*e, uid*/) => {
      //   //   this.api.setMaterial(m);
      //   // });
      // }
    });
  }

  getTextureList() {

    console.log('getTextureList!');
    let url = 'https://mygsgkit.giessegi.com/esempio-sketchfab/images/outfits/shirt_variation_9_4096x4096.png';
    // this.Utility.api.addTexture(url, function(err, textureUid) {
    //     console.log('New texture registered with ID ' + textureUid);
    // });

    // this.Utility.api.getTextureList( (err, textures) => {
    //   console.log(err ? err : textures);
    // });

    let textureUids = [
      "4d8b5120a4e04f43a07eabe1ac47f5ba",
      "39d0ec62067d46698fd353ab74f67798",
      "4d8b5120a4e04f43a07eabe1ac47f5ba",
      "6b4015c64f304f83bcccc91abaaa25b0",
      "8b51bede6b664408aca4284da5f62435"
    ];

    textureUids.forEach((uid) => {
      this.Utility.api.updateTexture(url, uid, function(err, textureUid) {
        console.log('replaced texture with uid: ' + textureUid);
      });
    });
  }

  updateMaterials(params) {

    this.Utility.removeTextureFromMaterialChannel("shirt", this.Utility.AlbedoPBR);
    this.Utility.removeTextureFromMaterialChannel("pants_1", this.Utility.AlbedoPBR);
    this.Utility.removeTextureFromMaterialChannel("pants_2", this.Utility.AlbedoPBR);

    const d = new Date();

    // const shirtURL = 'https://mygsgkit.giessegi.com/test-efesto/' + model + '_shirt.svg';
    // const pantsURL = 'https://mygsgkit.giessegi.com/test-efesto/' + model + '_pants.svg';
    const shirtURL = 'https://mygsgkit.giessegi.com/test2/svg-generator.php?file=' + params.shirt + '&t=' + d.getTime();
    const pantsURL = 'https://mygsgkit.giessegi.com/test2/svg-generator.php?file=' + params.pants + '&t=' + d.getTime();

    const cacheIDShirt = "shirt-" + params.shirt;
    const cacheIDpants = "pants-" + params.pants;

    this.Utility.setMaterialUIDPending("shirt", this.Utility.AlbedoPBR, cacheIDShirt);
    this.Utility.setMaterialUIDPending("pants_1", this.Utility.AlbedoPBR, cacheIDpants);
    this.Utility.setMaterialUIDPending("pants_2", this.Utility.AlbedoPBR, cacheIDpants);

    this.Utility.addTexture(shirtURL, cacheIDShirt, false);
    this.Utility.addTexture(pantsURL, cacheIDpants, false);
  }

}